<template lang="html">
  <div class="register-main">
    <img class="cydex-logo" src="../../assets/images/entrance-logo.png" alt="">
    <el-form :model="form" :rules="rules" ref="rulesForm" label-width="100%" label-position="top">
      <el-form-item :label="message.email" style="text-align:left" prop="email" auto-complete="off">
        {{form.email}}
      </el-form-item>
      <el-form-item  :label="message.Fl125" style="text-align:left">
        <el-col :span="24">
          <el-form-item prop="account" style="text-align:left">
            <el-input v-model.trim="form.account"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item  :label="message.name" style="text-align:left">
        <el-col :span="24">
          <el-form-item prop="surname" style="text-align:left">
            <el-input v-model.trim="form.surname"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="message.pass1" style="text-align:left" prop="pass">
        <el-input type="password" v-model="form.pass"></el-input>
      </el-form-item>
      <el-form-item :label="message.pass2" style="text-align:left" prop="pass2">
        <el-input type="password" v-model="form.pass2"></el-input>
      </el-form-item>
      <!-- <el-form-item prop="rules" class="rules">
         <el-checkbox v-model="form.rules">{{message.Pl149.l0}}<a href="/app/terms" target="_blank">{{message.Pl149.l1}}</a></el-checkbox>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" style="width:100%;margin-top:10px" @click="onSubmit">{{ message.Fl100 }}</el-button>
      </el-form-item>
    </el-form>
    <!-- <div class="register-register" @click="toRegiser()">
      {{ message.login }}>>
    </div> -->
  </div>
</template>

<script>
export default {
  data () {
    var email = this.$route.query.email
    var checkAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l159))
      } else if (value.length > 20) {
        return callback(new Error(this.$lang.ui.prompt.l160))
      } else if (value.length < 3) {
        return callback(new Error(this.$lang.ui.prompt.l161))
      } else {
        callback()
      }
    }
    var checkSurname = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l102))
      } else if (value.length > 20) {
        return callback(new Error(this.$lang.ui.prompt.l106))
      } else if (value.length < 2) {
        return callback(new Error(this.$lang.ui.prompt.l107))
      } else {
        callback()
      }
    }
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l101))
      } else if (value.length < 8) {
        return callback(new Error(this.$lang.ui.prompt.l108))
      } else {
        callback()
      }
    }
    var checkPass2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l103))
      } else if (value !== this.form.pass) {
        callback(new Error(this.$lang.ui.prompt.l105))
      } else {
        callback()
      }
    }
    return {
      message: {
        name: this.$lang.ui.form.name,
        login: this.$lang.ui.form.login,
        pass1: this.$lang.ui.form.pass1,
        pass2: this.$lang.ui.form.pass2,
        email: this.$lang.ui.form.email,
        phone: this.$lang.ui.form.phone,
        Fl100: this.$lang.ui.form.l100,
        Fl125: this.$lang.ui.form.l125,
        identifying: this.$lang.ui.form.identifying,
        Pl149: this.$lang.ui.prompt.l149
      },
      form: {
        email: email,
        surname: '',
        pass: '',
        pass2: '',
        account: email.split('@')[0],
      },
      rules: {
        account: [
          { validator: checkAccount, trigger: 'blur' }
        ],
        surname: [
          { validator: checkSurname, trigger: 'blur' }
        ],
        pass: [
          { validator: checkPass, trigger: 'blur' }
        ],
        pass2: [
          { validator: checkPass2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.$store.dispatch('activeApp', true)
  },
  methods: {
    toRegiser () {
      this.$router.push({ path: '/app/login' })
    },
    register () {
      this.$http.post('/cydex/api/v1/register_complete', {
        'email': this.form.email,
        'user_name': this.form.surname,
        'password': this.form.pass2,
        'account': this.form.account,
      })
        .then(response => {
          var token = this.$route.query.token
          if (this._global.config.system === 'ios') {
            this.$router.push({ path: '/app/phone?token=' + token + '&email=' + this.form.email })
          } else if (this._global.config.system === 'android') {
            this.$router.push({ path: '/app/phone?token=' + token + '&email=' + this.form.email })
          } else {
            this.$router.push({ path: '/app/login?email=' + this.form.email })
          }
        })
    },
    onSubmit () {
      this.$refs['rulesForm'].validate((valid) => {
        if (valid) {
          this.register()
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.register-main {
  position: absolute;
  display: block;
  width: 420px;
  left: 50%;
  top: 5%;
  border: 1px solid #999;
  border-radius: 8px;
  margin-left: -210px;
  padding: 35px 60px 45px 60px;
}
.register-main .cydex-logo {
  display: block;
  width: 96px;
  margin: 0 auto;
  margin-bottom: 5px;
}
.identifying-main {
  width: 100%;
  height: 36px;
  overflow: hidden;
}
.identifying-img {
  margin-top: -8px;
  width: 100%;
}
.register-register {
  position: absolute;
  bottom: 15px;
  font-size: 15px;
  right: 50px;
  cursor: pointer;
  color: #20a0ff;
}
.rules a {
  color: #20a0ff;
  /*text-decoration: none;*/
}
@media (max-width: 650px) {
  .register-main {
    top: 10px;
    left: 30px;
    right: 30px;
    width: auto;
    margin: 0;
    margin-bottom: 20px;
    padding: 30px 35px 20px 35px;
  }
  .register-main .cydex-logo {
    position: relative;
    width: 96px;
    margin: 0 auto;
    margin-bottom: 15px;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
}
</style>
